import Base from "../../../base";
import PosListLayout from "../layout";

export default class PosChooseList extends Base
{
    render() {
        return (
            <PosListLayout
                search={{
                   status:0,
                    company_id:this.app.getUrlParams('companyId')
                }}
                searchShow={false}
                hidden={['proddedAt']}
                canCheck={true}
                btnShow={false}
                oprationShow={false}
            />
        );
    }
}
